import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const EditAssignmentPage = loadable(() => import('./EditAssignmentPage'), {
  fallback: <BoxIndicator />,
});

export default EditAssignmentPage;
